import {Component, OnInit} from '@angular/core';
import {MeterFrameService} from '@app/api/nts';
import {FormControl, FormGroup} from '@angular/forms';
import {FormApiService} from '@app/core/services/form-api.service';
import { AlertService } from '@app/core/services/alert.service';

@Component({
  selector: 'app-meterframe-close',
  imports: [],
  templateUrl: './meterframe-close.component.html',
  styleUrl: './meterframe-close.component.css'
})
export class MeterframeCloseComponent implements OnInit {
  public id?: string;
  public canBeRemoved: boolean = false;
  public isLoading: boolean = true;

  constructor(
    private readonly meterFrameService: MeterFrameService,
    private readonly formApiService: FormApiService,
    private readonly alertService: AlertService,
  ) {
  }

  public ngOnInit(): void {
    this.meterFrameService.meterFrameValidateremoveGet(this.id).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.canBeRemoved = true;

        this.alertService.open('modal', 'info','meterFrame.meterFrameCanBeRemoved');
      },
      error: (error) => {
        this.isLoading = false;
        this.canBeRemoved = false;

        this.alertService.open('modal', 'danger','meterFrame.meterFrameCannotBeRemoved');
      }
    });
  }

  public submit(): void {
    if (!this.canBeRemoved) return;

    const submitForm = new FormGroup({
      id: new FormControl(this.id)
    });

    this.formApiService.submit(
      submitForm,
      () => this.meterFrameService.meterFrameRemoveGet(this.id),
      {
        successMessage: 'meterFrame.meterFrameRemoved',
        closeModal: true
      }
    );
  }
}
